if (!customElements.get('delivery-countdown')) {
  customElements.define('delivery-countdown', class DeliveryCountdown extends HTMLElement {
    constructor() {
      super();
      this.timer = null;
      this.cutoff = this.dataset.cutoff;
      // Default to 0 if not set
      this.leadDays = this.dataset.leadDays ? parseInt(this.dataset.leadDays, 10) : 0;
      
      this.countdownEl = this.querySelector('.countdown-timer');
      this.textEl = this.querySelector('.js-timer-text');
      
      this.originalTemplate = this.textEl ? this.textEl.innerHTML : '';

      this.daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      this.months = [
        'January', 'February', 'March', 'April', 'May', 'June', 
        'July', 'August', 'September', 'October', 'November', 'December'
      ];      
    }

    connectedCallback() {
      this.updateCountdown();
      this.timer = setInterval(() => this.updateCountdown(), 1000);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }

    parseCutoffTime() {
      if (!this.cutoff) return null;
      let cutoff = this.cutoff.trim().toLowerCase();
      let match = cutoff.match(/^(\d{1,2})(?:[.:](\d{2}))?\s*(am|pm)$/);
      if (!match) return null;

      let hour = parseInt(match[1], 10);
      let minute = match[2] ? parseInt(match[2], 10) : 0;
      let period = match[3];

      if (period === 'pm' && hour !== 12) hour += 12;
      if (period === 'am' && hour === 12) hour = 0;

      return { hour, minute };
    }

    isWeekend(date) {
      const day = date.getDay();
      return day === 0 || day === 6; 
    }

    calculateLeadDate(isPastCutoff) {
      let cursor = new Date();

      // 1. Cutoff Handling
      if (isPastCutoff) {
        cursor.setDate(cursor.getDate() + 1);
      }

      // 2. Start Check (Skip weekend start)
      while (this.isWeekend(cursor)) {
        cursor.setDate(cursor.getDate() + 1);
      }

      // 3. Add Production Days
      for (let i = 0; i < this.leadDays; i++) {
        cursor.setDate(cursor.getDate() + 1);
        while (this.isWeekend(cursor)) {
          cursor.setDate(cursor.getDate() + 1);
        }
      }

      // 4. Add Shipping Day
      cursor.setDate(cursor.getDate() + 1);
      while (this.isWeekend(cursor)) {
        cursor.setDate(cursor.getDate() + 1);
      }

      return cursor;
    }

    updateCountdown() {
      const cutoffTime = this.parseCutoffTime();
      if (!cutoffTime) return;

      const now = new Date();
      let cutoffDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoffTime.hour, cutoffTime.minute, 0, 0);

      const isPastCutoff = now > cutoffDate;
      if (isPastCutoff) cutoffDate.setDate(cutoffDate.getDate() + 1);

      // --- Update Timer UI ---
      const diffMs = cutoffDate - now;
      const totalSeconds = Math.max(0, Math.floor(diffMs / 1000));
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      if (this.countdownEl) {
        this.countdownEl.textContent = `${hours}h ${String(minutes).padStart(2, '0')}m ${String(seconds).padStart(2, '0')}s`;
      }

      // --- Update Text UI ---
      if (this.textEl) {
        const deliveryDate = this.calculateLeadDate(isPastCutoff);
        
        // 1. Generate the raw text string
        const rawDateString = `${this.daysOfWeek[deliveryDate.getDay()]} ${deliveryDate.getDate()} ${this.months[deliveryDate.getMonth()]}`;
        
        // 2. Create the version wrapped in a SPAN
        const styledDateString = `<span class="delivery-date">${rawDateString}</span>`;
        
        let newText = this.originalTemplate;
        
        // Replace 'tomorrow' logic
        if (newText.includes('tomorrow')) {
           newText = newText.replace(/tomorrow/i, styledDateString);
        }

        // Replace placeholders with the styled span
        newText = newText.replace(/\[\[date\]\]/g, styledDateString);
        newText = newText.replace(/\[\[days\]\]/g, styledDateString);
        
        this.textEl.innerHTML = newText;
      }
    }
  });
}